import { useQuery } from 'react-query';

import { getSRBMMonitoringHistory } from 'api/traps/SRBMTraps/getSRBMMonitoringHistory';

export const useGetSRBMMonitoringHistory = (slug: string) => {
  const { data, refetch, isLoading } = useQuery('GetSRBMMonitoringHistory', () => getSRBMMonitoringHistory(slug), {
    refetchOnWindowFocus: false,
    refetchInterval: 10000,
  });

  return { data, refetch, isLoading };
};

export default useGetSRBMMonitoringHistory;
